// extracted by mini-css-extract-plugin
export var container = "_89-0";
export var error = "_89-9";
export var label = "_89-5";
export var light = "_89-6";
export var md = "_89-3";
export var sm = "_89-2";
export var thin = "_89-8";
export var thinBold = "_89-7";
export var vertical = "_89-4";
export var xs = "_89-1";